import { render, staticRenderFns } from "./DepartmentsView.vue?vue&type=template&id=13f620c4&scoped=true"
import script from "./DepartmentsView.vue?vue&type=script&lang=js"
export * from "./DepartmentsView.vue?vue&type=script&lang=js"
import style0 from "./DepartmentsView.vue?vue&type=style&index=0&id=13f620c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f620c4",
  null
  
)

export default component.exports